export default __webpack_public_path__ + "static/media/Final_OPening-2_1.fa604372.gif";